<template>
	<BaseCard
		:is-editable="!isProcessFinished && isEditAllowed"
		:title="$t('overview_image').toString()"
		@clickEdit="$router.push({ name: 'damagecases.edit.thumbnail' })"
		:is-toggle-open="isToggleOpen"
		@toggleCard="toggleCard($event)"
		:is-toggleable="true"
	>
		<div class="-mr-2" v-if="overviewImage">
			<CoolLightBox :items="getLightBoxImages" :index="index" @close="index = null"></CoolLightBox>
			<div class="flex w-full flex-wrap justify-between">
				<div class="w-1/4 mr-2 pb-2 box-border flex-grow">
					<div
						:style="{ backgroundImage: 'url(' + overviewImage + ')' }"
						class="w-full bg-cover-overview bg-center h-56 cursor-pointer"
						@click="index = 0"
					></div>
				</div>
			</div>
		</div>
		<div class="font-bold" v-else>
			{{ $t('overview_image_not_stored') }}
		</div>
	</BaseCard>
</template>
<script>
import BaseCard from '@/components/damagecases/forms/BaseCard';

export default {
	name: 'MiscellaneousCard',
	components: { BaseCard },
	props: {
		isEditAllowed: { type: Boolean, default: true },
		isProcessFinished: {},
		overviewImage: {},
		isToggleOpen: { type: Boolean, default: true },
	},
	data() {
		return {
			index: null,
		};
	},
	computed: {
		getLightBoxImages() {
			return [this.overviewImage];
		},
	},
	methods: {
		toggleCard($event) {
			this.$emit('toggleCard', $event);
		},
	},
};
</script>

<style scoped>
.bg-cover-overview {
	background-size: contain;
	background-repeat: no-repeat;
}
</style>
